// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { BlockedTenantDTO } from './blocked-tenant-dto';

/**
 * 
 * @export
 * @interface ConflictingRepositDTO
 */
export interface ConflictingRepositDTO {
    /**
     * ID of the conflicting tenancy order
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    tenancyOrderId: string;
    /**
     * ID of the conflicting tenancy
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    tenancyId: string;
    /**
     * ID of the organization that owns the conflicting reposit
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    organizationId: string;
    /**
     * Name of the organization that owns the conflicting reposit
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    organizationName: string;
    /**
     * Start date of the conflicting tenancy
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    startDate: string;
    /**
     * Number of days apart from the proposed start date
     * @type {number}
     * @memberof ConflictingRepositDTO
     */
    daysApart: number;
    /**
     * Order status of the conflicting reposit when it belongs to the same organization. Pending and complete Reposits can block.
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    status?: ConflictingRepositDTOStatusEnum;
    /**
     * Whether the conflicting reposit belongs to the same organization
     * @type {boolean}
     * @memberof ConflictingRepositDTO
     */
    isSameOrganization: boolean;
    /**
     * Property address of the conflicting reposit when it belongs to the same organization and the tenancy has one
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    address?: string;
    /**
     * Term type of the conflicting tenancy when it belongs to the same organization. A move-out date can only be scheduled on a periodic tenancy.
     * @type {string}
     * @memberof ConflictingRepositDTO
     */
    termType?: ConflictingRepositDTOTermTypeEnum;
    /**
     * List of blocked tenants associated with this conflicting reposit
     * @type {Array<BlockedTenantDTO>}
     * @memberof ConflictingRepositDTO
     */
    blockedTenants: Array<BlockedTenantDTO>;
}

/**
    * @export
    * @enum {string}
    */
export enum ConflictingRepositDTOStatusEnum {
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE'
}
/**
    * @export
    * @enum {string}
    */
export enum ConflictingRepositDTOTermTypeEnum {
    FIXED = 'FIXED',
    PERIODIC = 'PERIODIC'
}



